module.exports = __webpack_public_path__ + "static/media/maze-background-half.66bbe67c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/maze-background-half.svg
// module id = 1639
// module chunks = 0